<template>
	<Menu.Item :value="value" class="menu-item">
		<slot />
	</Menu.Item>
</template>

<script setup lang="ts">
import { Menu } from "@ark-ui/vue"

defineProps<{
	value: string
}>()
</script>

<style scoped>
.menu-item {
	padding: var(--spacing-xs) var(--spacing-sm);
	border-radius: var(--border-radius-sm);
	font-size: var(--font-size-small);
	cursor: pointer;
	outline: none;
	white-space: nowrap;

	&:hover,
	&[data-highlighted] {
		background-color: var(--neutral-100);
	}
}
</style>
